// File Name :  Wholesale-all-in-one-module.js
// Updated Date: 25 march, 2025
//////////////////////////////////////////////

if(typeof window.WSAIO==='undefined'){window.WSAIO={};}if(typeof WSAIO.App==='undefined'){WSAIO.App={};}

  // ----------------------     Start order limit code --------------------------------
var $jscomp=$jscomp||{};$jscomp.scope={};$jscomp.arrayIteratorImpl=function(a){var b=0;return function(){return b<a.length?{done:!1,value:a[b++]}:{done:!0}}};$jscomp.arrayIterator=function(a){return{next:$jscomp.arrayIteratorImpl(a)}};$jscomp.makeIterator=function(a){var b="undefined"!=typeof Symbol&&Symbol.iterator&&a[Symbol.iterator];return b?b.call(a):$jscomp.arrayIterator(a)};
function log(a,b,c){if(WSAIO.debug)if("undefined"!==typeof c)switch(c){case "warning":console.warn(a,b);break;case "error":console.error(a,b);break;case "info":console.info(a,b);break;default:console.log(a,b)}else console.log(a,b)};
function mF(a){if(isNaN(a)||null==a)return 0;a=a.toString();if("string"==typeof a&&-1<a.indexOf("."))return 2>a.split(".")[1].length?Number(a).toFixed(2).toString():a.toString();a=(Number(a)/100).toFixed(2);return a.toString()};
window.WSAIO_MODULEJS=function(){

  if(typeof WSAIO.use_currencyRates != 'undefined' &&  WSAIO.use_currencyRates == 'manual' && (WSAIO.market_selected != undefined && typeof WSAIO.customer.default_address.country_code != 'undefined' && WSAIO.market_selected != WSAIO.customer.default_address.country_code)){
  WSAIO.country_currency_code  = { "AD": "EUR_€", "AE": "AED_د.إ.", "AF": "AFN_؋", "AL": "ALL_Lek", "AM": "AMD_դր.", "AR": "ARS_$", "AS": "USD_$", "AT": "EUR_€", "AU": "AUD_$", "AX": "EUR_€", "AZ": "AZN_ман.", "BA": "BAM_KM", "BD": "BDT_৳", "BE": "EUR_€", "BF": "XOF_CFA", "BG": "BGN_лв.", "BH": "BHD_د.ب.", "BI": "BIF_FBu", "BJ": "XOF_CFA", "BL": "EUR_€", "BN": "BND_$", "BO": "BOB_Bs", "BQ": "USD_$", "BR": "BRL_R$", "BV": "NOK_kr", "BW": "BWP_P", "BZ": "BZD_$", "CA": "CAD_$", "CC": "AUD_$", "CD": "CDF_FrCD", "CF": "XAF_FCFA", "CG": "XAF_FCFA", "CH": "CHF_CHF", "CI": "XOF_CFA", "CK": "NZD_$", "CL": "CLP_$", "CM": "XAF_FCFA", "CN": "CNY_CN¥", "CO": "COP_$", "CR": "CRC_₡", "CV": "CVE_CV$", "CX": "AUD_$", "CY": "EUR_€", "CZ": "CZK_Kč", "DE": "EUR_€", "DJ": "DJF_Fdj", "DK": "DKK_kr", "DO": "DOP_RD$", "DZ": "DZD_د.ج.", "EC": "USD_$", "EE": "EUR_€", "EG": "EGP_ج.م.", "EH": "MAD_د.م.", "ER": "ERN_Nfk", "ES": "EUR_€", "ET": "ETB_Br", "FI": "EUR_€", "FM": "USD_$", "FO": "DKK_kr", "FR": "EUR_€", "GA": "XAF_FCFA", "GB": "GBP_£", "GE": "GEL_GEL", "GF": "EUR_€", "GG": "GBP_£", "GH": "GHS_GH₵", "GL": "DKK_kr", "GN": "GNF_FG", "GP": "EUR_€", "GQ": "XAF_FCFA", "GR": "EUR_€", "GS": "GBP_£", "GT": "GTQ_Q", "GU": "USD_$", "GW": "XOF_CFA", "HK": "HKD_$", "HM": "AUD_$", "HN": "HNL_L", "HR": "HRK_kn", "HU": "HUF_Ft", "ID": "IDR_Rp", "IE": "EUR_€", "IL": "ILS_₪", "IM": "GBP_£", "IN": "INR_টকা", "IO": "USD_$", "IQ": "IQD_د.ع.", "IR": "IRR_﷼", "IS": "ISK_kr", "IT": "EUR_€", "JE": "GBP_£", "JM": "JMD_$", "JO": "JOD_د.أ.", "JP": "JPY_￥", "KE": "KES_Ksh", "KH": "KHR_៛", "KI": "AUD_$", "KM": "KMF_FC", "KR": "KRW_₩", "KW": "KWD_د.ك.", "KZ": "KZT_тңг.", "LB": "LBP_ل.ل.", "LI": "CHF_CHF", "LK": "LKR_SL Re", "LT": "EUR_€", "LU": "EUR_€", "LV": "EUR_€", "LY": "LYD_د.ل.", "MA": "MAD_د.م.", "MC": "EUR_€", "MD": "MDL_MDL", "ME": "EUR_€", "MF": "EUR_€", "MG": "MGA_MGA", "MH": "USD_$", "MK": "MKD_MKD", "ML": "XOF_CFA", "MM": "MMK_K", "MO": "MOP_MOP$", "MP": "USD_$", "MQ": "EUR_€", "MT": "EUR_€", "MU": "MUR_MURs", "MX": "MXN_$", "MY": "MYR_RM", "MZ": "MZN_MTn", "NA": "NAD_N$", "NE": "XOF_CFA", "NF": "AUD_$", "NG": "NGN_₦", "NI": "NIO_C$", "NL": "EUR_€", "NO": "NOK_kr", "NP": "NPR_नेरू", "NR": "AUD_$", "NU": "NZD_$", "NZ": "NZD_$", "OM": "OMR_ر.ع.", "PA": "PAB_B/.", "PE": "PEN_S/.", "PH": "PHP_₱", "PK": "PKR_₨", "PL": "PLN_zł", "PM": "EUR_€", "PN": "NZD_$", "PR": "USD_$", "PS": "ILS_₪", "PT": "EUR_€", "PW": "USD_$", "PY": "PYG_₲", "QA": "QAR_ر.ق.", "RE": "EUR_€", "RO": "RON_RON", "RS": "RSD_дин.", "RU": "RUB_₽.", "RW": "RWF_FR", "SA": "SAR_ر.س.", "SD": "SDG_SDG", "SE": "SEK_kr", "SG": "SGD_$", "SI": "EUR_€", "SJ": "NOK_kr", "SK": "EUR_€", "SM": "EUR_€", "SN": "XOF_CFA", "SO": "SOS_Ssh", "SV": "USD_$", "SY": "SYP_ل.س.", "TC": "USD_$", "TD": "XAF_FCFA", "TF": "EUR_€", "TG": "XOF_CFA", "TH": "THB_฿", "TK": "NZD_$", "TL": "USD_$", "TN": "TND_د.ت.", "TO": "TOP_T$", "TR": "TRY_TL", "TT": "TTD_$", "TV": "AUD_$", "TW": "TWD_NT$", "TZ": "TZS_TSh", "UA": "UAH_₴", "UG": "UGX_USh", "UM": "USD_$", "US": "USD_$", "UY": "UYU_$", "UZ": "UZS_UZS", "VA": "EUR_€", "VE": "VEF_Bs.F.", "VG": "USD_$", "VI": "USD_$", "VN": "VND_₫", "XK": "EUR_€", "YE": "YER_ر.ي.", "YT": "EUR_€", "ZA": "ZAR_R", "ZW": "ZWL_ZWL$" }
   }
var alert_msg = '';WSAIO.ol_message = '';	
WSAIO.wsaioUpSell_msg = '';	
WSAIO.disable_checkout_define = function(a, b, d) {
    d = d || WSAIO.checkout_selector;

    if (a || WSAIO.disable_checkout) {
        if (document.querySelectorAll(".waio-orderControl-message").length > 0) {
        } else {
            WSAIO.default_limit = true;
        }
    } else {
        WSAIO.default_limit = false;
    }
}
function convert_subtotal_weight(weight,unit) {
    // Convert weight to shop weight since we have weight in grams from shopify
                 var cart_total_weight = 0;
                  if(typeof unit !== "undefined" && unit){
                    switch (unit) {
                        case "lb": // approximate (Unit system => Imperial)
                            cart_total_weight = Number((weight / 453.592).toFixed(3));
                            break;
                  
                        case "kg": // Exact (Unit system => Metric)
                            cart_total_weight = weight / 1000;
                            break;
                  
                        case "oz": // approximate (Unit system => Imperial)
                            cart_total_weight = Number((weight / 28.3495).toFixed(3));
                            break;
                  
                        default:
                            cart_total_weight = weight;
                            break;
                    }
                  }
                 return cart_total_weight;
}
function getMsg_define(scope,relation,value,allow) {
   if(!allow){
      if(relation == "equal" || relation == "not_equal"){
         if(Object.keys(WSAIO.ol_message || {}).length === 0){
             WSAIO.ol_message = scope+' must be '+relation+' to '+value;
          } else{ 
             WSAIO.ol_message = WSAIO.ol_message+' AND '+scope+' must be '+relation+' to '+value;
          }
      }else{
          if(Object.keys(WSAIO.ol_message || {}).length === 0){
             WSAIO.ol_message = scope+' must be '+relation+' '+value;
          } else{
             WSAIO.ol_message = WSAIO.ol_message+' AND '+scope+' must be '+relation+' '+value;
          }
      }
    }
    return WSAIO.ol_message;
}
WSAIO.minOrderControl_define = function() {
  var oc_price = 0;
  if(waioMOC.rules == undefined) return false
   for (var a = [], b = 0; b < waioMOC.rules.length; b++) {
                  var d = waioMOC.rules[b];
                  "active" === d.status && mocIsValidCustomer(d) && a.push(d);
                }
                if (0 < a.length) {
                  b = {};
                  if (1 === a.length) b = a[0];
                  else {
                    d = a.findIndex(function (a) {
                      return "tag_based" === a.customer_group;
                    });
                    var c = a.findIndex(function (a) {
                      return "logged_in" === a.customer_group;
                    }),
                        e = a.findIndex(function (a) {
                          return "all" === a.customer_group;
                        });
                    -1 < d ? (b = a[d]) : -1 < c ? (b = a[c]) : -1 < e && (b = a[e]);
                  }
                  log(b);
                 var opening_rule_applied = false;
                  if("undefined" !== typeof b.rules && "undefined" !== typeof b.condition_scope &&
                     "undefined" !== typeof b.opening_rules && "undefined" !== typeof customer_order_info &&
                     (b.condition_scope == 'separate' || b.condition_scope == 'opening_only') && 
                     customer != '' && parseInt(customer_order_info) == 0){
                    opening_rule_applied = true;
                   
                  }
                if("undefined" !== typeof b.condition_scope && b.condition_scope == 'opening_only') b.rules = [];
                 if(opening_rule_applied){
                      b.rules = b.opening_rules;
                  }
                  if ("undefined" !== typeof b.rules) {
                    a = [];WSAIO.ol_message = '';
                    d = $jscomp.makeIterator(b.rules);
                    for (c = d.next(); !c.done; c = d.next()){
                    switch (((c = c.value), c.column)) {
                      case "cart_original_total_price":
                        if(Shopify != undefined && Shopify.currency != undefined && Shopify.currency.rate != undefined && Shopify.currency.active != WSAIO.shopInfo.currency){
                          oc_price = Number((Number(c.condition) * Shopify.currency.rate).toFixed(2));
                           WSAIO.show_dynamic_OL_msg = true;
                        }else{
                          oc_price = Number(c.condition)
                        }
                        switch (c.relation) {
                          case "equal":
                            oc_price == mF(Number(waioMOC.cart.original_total_price)) ? a.push("yes") : a.push("no");
                            alert_msg = getMsg_define('subtotal',c.relation,oc_price,oc_price == mF(Number(waioMOC.cart.original_total_price)));
                            break;
                          case "not_equal":
                            oc_price != mF(Number(waioMOC.cart.original_total_price)) ? a.push("yes") : a.push("no");
                            alert_msg = getMsg_define('subtotal',c.relation,oc_price,oc_price != mF(Number(waioMOC.cart.original_total_price)));
                            break;
                          case "greater_than":
                            oc_price < mF(Number(waioMOC.cart.original_total_price)) ? a.push("yes") : a.push("no");
                            alert_msg = getMsg_define('Subtotal',c.relation,oc_price,oc_price < mF(Number(waioMOC.cart.original_total_price)));
                            break;
                          case "less_than":
                            oc_price > mF(Number(waioMOC.cart.original_total_price)) ? a.push("yes") : a.push("no");
                            alert_msg = getMsg_define('Subtotal',c.relation,oc_price,oc_price > mF(Number(waioMOC.cart.original_total_price)));
                            break;
                          case "greater_than_equal_to":
                            oc_price <= mF(Number(waioMOC.cart.original_total_price)) ? a.push("yes") : a.push("no");
                             alert_msg = getMsg_define('Subtotal',c.relation,oc_price,oc_price <= mF(Number(waioMOC.cart.original_total_price)));
                            break;
                          case "less_than_equal_to":
                            oc_price >= mF(Number(waioMOC.cart.original_total_price)) ? a.push("yes") : a.push("no");
                            alert_msg = getMsg_define('Subtotal',c.relation,oc_price,oc_price >= mF(Number(waioMOC.cart.original_total_price)));
                            break;
                          default:
                            console.log("invalid relation value");
                        }
                        break;
                      case "cart_item_count":
                        switch (c.relation) {
                          case "equal":
                            Number(c.condition) == Number(waioMOC.cart.item_count) ? a.push("yes") : a.push("no");
                            alert_msg = getMsg_define('Cart Items',c.relation,Number(c.condition),Number(c.condition) == Number(waioMOC.cart.item_count));
                            break;
                          case "not_equal":
                            Number(c.condition) != Number(waioMOC.cart.item_count) ? a.push("yes") : a.push("no");
                            alert_msg = getMsg_define('Cart Items',c.relation,Number(c.condition),Number(c.condition) != Number(waioMOC.cart.item_count));
                            break;
                          case "greater_than":
                            Number(c.condition) < Number(waioMOC.cart.item_count) ? a.push("yes") : a.push("no");
                            alert_msg = getMsg_define('Cart Items',c.relation,Number(c.condition),Number(c.condition) < Number(waioMOC.cart.item_count));
                            break;
                          case "less_than":
                            Number(c.condition) > Number(waioMOC.cart.item_count) ? a.push("yes") : a.push("no");
                            alert_msg = getMsg_define('Cart Items',c.relation,Number(c.condition),Number(c.condition) > Number(waioMOC.cart.item_count));
                            break;
                          case "greater_than_equal_to":
                            Number(c.condition) <= Number(waioMOC.cart.item_count) ? a.push("yes") : a.push("no");
                            alert_msg = getMsg_define('Cart Items',c.relation,Number(c.condition),Number(c.condition) <= Number(waioMOC.cart.item_count));
                             break;
                          case "less_than_equal_to":
                            Number(c.condition) >= Number(waioMOC.cart.item_count) ? a.push("yes") : a.push("no");
                            alert_msg = getMsg_define('Cart Items',c.relation,Number(c.condition),Number(c.condition) >= Number(waioMOC.cart.item_count));
                            break;
                          default:
                            console.log("invalid relation valueh");
                        }
                        break;
                      case "cart_total_weight":
                        var subtotal_weight = convert_subtotal_weight(Number(waioMOC.cart.total_weight),'g');
                        if("undefined" !== typeof b.weight_unit){
                           subtotal_weight = convert_subtotal_weight(Number(waioMOC.cart.total_weight),b.weight_unit);
                        }
                        switch (c.relation) {
                          case "equal":
                            Number(c.condition) == subtotal_weight ? a.push("yes") : a.push("no");
                            alert_msg = getMsg_define('Cart Total Weight',c.relation,Number(c.condition),Number(c.condition) == subtotal_weight);
                            break;
                          case "not_equal":
                            Number(c.condition) != subtotal_weight ? a.push("yes") : a.push("no");
                             alert_msg = getMsg_define('Cart Total Weight',c.relation,Number(c.condition),Number(c.condition) != subtotal_weight);
                            break;
                          case "greater_than":
                            Number(c.condition) < subtotal_weight ? a.push("yes") : a.push("no");
                             alert_msg = getMsg_define('Cart Total Weight',c.relation,Number(c.condition),Number(c.condition) < subtotal_weight);
                            break;
                          case "less_than":
                            Number(c.condition) > subtotal_weight ? a.push("yes") : a.push("no");
                             alert_msg = getMsg_define('Cart Total Weight',c.relation,Number(c.condition),Number(c.condition) > subtotal_weight );
                            break;
                          case "greater_than_equal_to":
                            Number(c.condition) <= subtotal_weight ? a.push("yes") : a.push("no");
                             alert_msg = getMsg_define('Cart Total Weight',c.relation,Number(c.condition),Number(c.condition) <= subtotal_weight);
                            break;
                          case "less_than_equal_to":
                            Number(c.condition) >= subtotal_weight ? a.push("yes") : a.push("no");
                             alert_msg = getMsg_define('Cart Total Weight',c.relation,Number(c.condition),Number(c.condition) >= subtotal_weight);
                            break;
                          default:
                            console.log("invalid relation");
                        }
                        break;
                      default:
                        console.log("invalid column");
                      }
                    }
                    log(a);

                    if(opening_rule_applied && "undefined" !== typeof b.opening_message){
                      b.message = b.opening_message;
                      b.rules_operator = b.opening_rules_operator;
                      if(WSAIO.show_dynamic_OL_msg || b.opening_message == '') b.message = alert_msg;
                    }else{
                      if(WSAIO.show_dynamic_OL_msg || b.message == '') b.message = alert_msg;
                    }
                    waioMOC.oc = b;
                    "and" === b.rules_operator
                    ? -1 < a.indexOf("no")
                    ? ((WSAIO.disable_checkout = !0), (WSAIO.checkout_message = b.message), WSAIO.disableCheckout(!0, b.message))
                    : ((WSAIO.disable_checkout = !1), (WSAIO.checkout_message = b.message), WSAIO.disableCheckout(!1, b.message))
                    : -1 === a.indexOf("yes")
                    ? ((WSAIO.disable_checkout = !0), (WSAIO.checkout_message = b.message), WSAIO.disableCheckout(!0, b.message))
                    : ((WSAIO.disable_checkout = !1), (WSAIO.checkout_message = b.message), WSAIO.disableCheckout(!1, b.message));
                  } else log("Something missing in MOC");
                } else log("Minimum Order Control"), log("Minimum Order Control");
}
 function mocIsValidCustomer(a){var b=!0;"all"!==a.customer_group?(is_loggedIn||(b=!1),"tag_based"===a.customer_group?isTagged(a.customer_tags)||(b=!1):a.except_tags&&isTagged(a.excepted_tags)&&(b=!1)):(a.except_tags&&isTagged(a.excepted_tags)&&(b=!1),a.except_logged_in&&is_loggedIn&&(b=!1));return b}
function isTagged(a){if("undefined"===typeof a||!is_loggedIn)return!1;var b=!1,d=customer_tags.map(function(a){return a.toLowerCase()});a=a.map(function(a){return a.toLowerCase()});a=$jscomp.makeIterator(a);for(var c=a.next();!c.done;c=a.next())if(-1<d.indexOf(c.value)){b=!0;break}return b};


//  --------------------- Start buy now order limit code -----------------------

 WSAIO.BuyNoworderControl = function(c,m,e,b,d,v){
                var oc_price = 0;
                var Total_quantity = m;
                var check_volumeTable = false;
                var compare_row = 0;
                var variant_id = v;
                var variant_inventory_info = {};
                var inventory_issue = false;
                if(typeof WSAIO.default_product_variant != 'undefined' && WSAIO.default_product_variant.length > 0){
                    variant_inventory_info = WSAIO.default_product_variant.find(function(e,r){return e.variant_id == variant_id})
                }
                if(variant_inventory_info != undefined && Object.keys(variant_inventory_info).length){
                      if(variant_inventory_info.variant_inventory_management != undefined && variant_inventory_info.variant_inventory_management != ''){
                           if(variant_inventory_info.variant_inventory_policy == 'deny'){
                             if(parseInt(Total_quantity) > parseInt(variant_inventory_info.variant_inventory_quantity)){
                               Total_quantity = variant_inventory_info.variant_inventory_quantity;
                               inventory_issue = true;
                             }
                           }
                      }
                }
              var total_price = (c*Total_quantity)/100;
                try{
                if(b.length > 0 && Total_quantity >= Number(WSAIO.volume_values[0].qty)){
                  check_volumeTable = true;
                  if (WSAIO.volume_values) {
                      WSAIO.volume_values.forEach(function(item, e) {
                          if (Total_quantity >= Number(item.qty)) {
                              compare_row = e;
                          }
                      });
                  }
                   total_price = (Number(d/100)-Number(WSAIO.get_discount(d/100,WSAIO.volume_values[compare_row].type,WSAIO.volume_values[compare_row].value)))*Total_quantity;
                }
                }catch(e){}
               for (var a = [], b = 0; b < waioMOC.rules.length; b++) {
                 var d = waioMOC.rules[b];
                 "active" === d.status && mocIsValidCustomer(d) && a.push(d);
               }
                if (0 < a.length) {
                  b = {};
                  if (1 === a.length) b = a[0];
                  else {
                    d = a.findIndex(function (a) {
                      return "tag_based" === a.customer_group;
                    });
                    var c = a.findIndex(function (a) {
                      return "logged_in" === a.customer_group;
                    }),
                        e = a.findIndex(function (a) {
                          return "all" === a.customer_group;
                        });
                    -1 < d ? (b = a[d]) : -1 < c ? (b = a[c]) : -1 < e && (b = a[e]);
                  }
                  var opening_rule_applied = false;
                  if("undefined" !== typeof b.rules && "undefined" !== typeof b.condition_scope &&
                     "undefined" !== typeof b.opening_rules && "undefined" !== typeof customer_order_info &&
                     (b.condition_scope == 'separate' || b.condition_scope == 'opening_only') && 
                     customer != '' && parseInt(customer_order_info) == 0){
                    opening_rule_applied = true;
                   
                  }
                if("undefined" !== typeof b.condition_scope && b.condition_scope == 'opening_only') b.rules = [];
                 if(opening_rule_applied){
                      b.rules = b.opening_rules;
                  }
                  if ("undefined" !== typeof b.rules) {
                    a = [];WSAIO.ol_message = '';
                    d = $jscomp.makeIterator(b.rules);
                    for (c = d.next(); !c.done; c = d.next())
                   switch (((c = c.value), c.column)) {
                      case "cart_original_total_price":
                         if(Shopify != undefined && Shopify.currency != undefined && Shopify.currency.rate != undefined && Shopify.currency.active != WSAIO.shopInfo.currency){
                             oc_price = Number((Number(c.condition) * Shopify.currency.rate).toFixed(2));
                             WSAIO.show_dynamic_OL_msg = true;
                          }else{
                            oc_price = Number(c.condition)
                          }
                        switch (c.relation) {
                          case "equal":
                            oc_price == Number(total_price) ? a.push("yes") : a.push("no");
                            alert_msg = getMsg_define('subtotal',c.relation,oc_price,oc_price == Number(total_price));
                            break;
                          case "not_equal":
                            oc_price != Number(total_price) ? a.push("yes") : a.push("no");
                             alert_msg = getMsg_define('subtotal',c.relation,oc_price,oc_price != Number(total_price));
                            break;
                          case "greater_than":
                              oc_price < Number(total_price) ? a.push("yes") : a.push("no");
                            alert_msg = getMsg_define('subtotal',c.relation,oc_price, oc_price < Number(total_price));
                            break;
                          case "less_than":
                            oc_price > Number(total_price) ? a.push("yes") : a.push("no");
                            alert_msg = getMsg('subtotal',c.relation,oc_price, oc_price > Number(total_price));
                            break;
                          case "greater_than_equal_to":
                            oc_price <= Number(total_price) ? a.push("yes") : a.push("no");
                            alert_msg = getMsg_define('subtotal',c.relation,oc_price, oc_price <= Number(total_price));
                             break;
                          case "less_than_equal_to":
                            oc_price >= Number(total_price) ? a.push("yes") : a.push("no");
                            alert_msg = getMsg_define('subtotal',c.relation,oc_price, oc_price >= Number(total_price));
                            break;
                          default:
                            console.log("invalid relation value in MOC's nested switch");
                        }
                        break;
                      case "cart_item_count":
                        switch (c.relation) {
                          case "equal":
                            Number(c.condition) == Number(Total_quantity) ? a.push("yes") : a.push("no");
                            alert_msg = getMsg_define('Cart Items',c.relation,Number(c.condition),Number(c.condition) == Number(Total_quantity));
                            break;
                          case "not_equal":
                            Number(c.condition) != Number(Total_quantity) ? a.push("yes") : a.push("no");
                            alert_msg = getMsg_define('Cart Items',c.relation,Number(c.condition),Number(c.condition) != Number(Total_quantity));
                            break;
                          case "greater_than":
                            Number(c.condition) < Number(Total_quantity) ? a.push("yes") : a.push("no");
                            alert_msg = getMsg_define('Cart Items',c.relation,Number(c.condition),Number(c.condition) < Number(Total_quantity));
                            break;
                          case "less_than":
                            Number(c.condition) > Number(Total_quantity) ? a.push("yes") : a.push("no");
                            alert_msg = getMsg_define('Cart Items',c.relation,Number(c.condition),Number(c.condition) > Number(Total_quantity));
                            break;
                          case "greater_than_equal_to":
                            Number(c.condition) <= Number(Total_quantity) ? a.push("yes") : a.push("no");
                            alert_msg = getMsg_define('Cart Items',c.relation,Number(c.condition),Number(c.condition) <= Number(Total_quantity));
                            break;
                          case "less_than_equal_to":
                            Number(c.condition) >= Number(Total_quantity) ? a.push("yes") : a.push("no");
                            alert_msg = getMsg_define('Cart Items',c.relation,Number(c.condition),Number(c.condition) >= Number(Total_quantity));
                            break;
                          default:
                            console.log("invalid relation valueswitch");
                        }
                        break;
                      default:
                        console.log("invalid column value  switch");
                    }
                    if(opening_rule_applied && "undefined" !== typeof b.opening_message){
                      b.message = b.opening_message;
                      b.rules_operator = b.opening_rules_operator;
                      if(WSAIO.show_dynamic_OL_msg || b.opening_message == '') b.message = alert_msg;
                    }else{
                      if(WSAIO.show_dynamic_OL_msg || b.message == '') b.message = alert_msg;
                    }
                    waioMOC.oc = b;
                    "and" === b.rules_operator
                    ? -1 < a.indexOf("no")
                    ? ((WSAIO.disable_buy_now_button = !0), (WSAIO.buyNow_message = b.message))
                    : ((WSAIO.disable_buy_now_button = !1), (WSAIO.buyNow_message = b.message))
                    : -1 === a.indexOf("yes")
                    ? ((WSAIO.disable_buy_now_button = !0), (WSAIO.buyNow_message = b.message))
                    : ((WSAIO.disable_buy_now_button = !1), (WSAIO.buyNow_message = b.message));
                    function disable_buyitnow(){
                      const el5 = document.querySelectorAll(WSAIO.buy_now_button_selector);
                      el5.forEach(function(element) {
                          element.classList.remove('checkout-disabled');
                          element.removeAttribute('disabled');
                      });
                    }

                    if(WSAIO.disable_buy_now_button){
                      
                       if(typeof waioMOC.oc != 'undefined' && typeof waioMOC.oc.allow_retail_price_if_conditions_not_met  != 'undefined' && waioMOC.oc.allow_retail_price_if_conditions_not_met){
                         WSAIO.allow_normal_checkout__OC = true;
                         return false;
                      }
                      
                      document.querySelectorAll('.waio_buy_message').forEach(function(element) {element.remove();});
                      if(WSAIO.buyNow_message != '' && document.querySelectorAll('.waio_buy_message').length === 0){
                        if(typeof WSAIO.allow_normal_checkout__OC == 'undefined' || WSAIO.allow_normal_checkout__OC == false){
                              const el1 = document.querySelectorAll(WSAIO.shopify_payment_button_wrapper);
                              const htmlContent1 = '<p class="waio_buy_message" style="font-size: 14px;">' + WSAIO.buyNow_message + '</p>';
                              el1.forEach(function(targetElement) {
                                  targetElement.insertAdjacentHTML('afterend', htmlContent1);
                              });
                             if(inventory_issue){
                              const el2 = document.querySelectorAll(WSAIO.shopify_payment_button_wrapper);
                              const htmlContent2 = '<p class="waio_buy_message" style="font-size: 14px;color:red;">Maximum allowable quantity for selected variant is ' + Total_quantity + '.</p>';
                              el2.forEach(function(targetElement) {
                                  targetElement.insertAdjacentHTML('afterend', htmlContent2);
                              });
                             }
                        }else{
                                const el16 = document.querySelector(WSAIO.shopify_payment_button_wrapper);
                                if (el16) {
                                    const htmlToInsert5 = '<p class="waio_buy_message" style="font-size: 14px;color:red;">Fulfill minimum order requirements to avail discount</p>';
                                    el16.insertAdjacentHTML('afterend', htmlToInsert5);
                                }
                               const el3 = document.querySelectorAll(WSAIO.shopify_payment_button_wrapper);
                               const htmlContent3 = '<p class="waio_buy_message" style="font-size: 14px;">' + WSAIO.buyNow_message + '</p>';
                                el3.forEach(function(targetElement) {
                                    targetElement.insertAdjacentHTML('afterend', htmlContent3);
                                });
                         }
                      }
                      const el4 = document.querySelectorAll(WSAIO.buy_now_button_selector);
                      el4.forEach(function(element) {
                          element.classList.add('checkout-disabled');
                          element.setAttribute('disabled', 'disabled');
                      });
                      setTimeout(function(){
                       disable_buyitnow()
                       document.querySelectorAll('.waio_buy_message').forEach(function(element) {element.remove();});
                      },2500);
                    }else{
                     disable_buyitnow()
                    }
                  }
                }
    };

// -------------------------- get cart info object ------------------
WSAIO.fetchCart_define  = function(){
    if(!WSAIO.fetchCart){
                WSAIO.fetchCart = function(b) {
                var url_string = WSAIO.local_param+"cart.js";
                if(typeof Shopify.currency.active != 'undefined' && Shopify.currency.active != null && Shopify.currency.active != '' && typeof window.token_enable == 'undefined'){
                  url_string = url_string+'?currency='+Shopify.currency.active;
                }
                $.ajax({type:"GET", url:url_string, cache:!1, dataType:"json", success:function(f) {
                  var d = [];
                  f && f.items && 0 < f.items.length && (f.items.forEach(function(e, c) {
                    try {
                      delete e.product_description, delete e.featured_image, delete e.url, delete e.options_with_values, delete e.variant_options, delete e.product_description;
                    } catch (h) {
                      k(h);
                    }
                    d.push(e);
                  }), f.items = d);
                  try {
                    "undefined" === typeof window.waioMOC && (window.waioMOC = {});
                    "undefined" === typeof waioMOC.cart && (waioMOC.cart = {});
                    try {
                      waioMOC.cart.item_count = f.item_count;
                    } catch (e) {
                    }
                  } catch (e) {
                  }
                  "function" === typeof b && b(null, f);
                }, error:function(f) {
                  "function" === typeof b && b(f, null);
                }});
              };
            }
};


// ---------------------  append wholesale link code start ----------

WSAIO.loginLink = function() {
  if(WSAIO.app_mode_applied && typeof WSAIO.form_related_page_found != 'undefined' && WSAIO.form_related_page_found){
              function append_link(){
                      if(document.querySelectorAll('.wsaio_form').length === 0){
                        const defaultSelector = WSAIO.default_create_account_selector;
                        let selector_wsf = document.querySelector(defaultSelector);
                        console.log(selector_wsf)
                        if (!selector_wsf) {
                            const loginForm = document.querySelector('form[action$="/account/login"]');
                              
                              if (loginForm) {
                                  const formSiblings = loginForm.parentNode.children;
                                  let foundLink = null;
                                  const siblingLinks = loginForm.parentNode.querySelectorAll('form[action$="/account/login"] ~ * a[href$="/account/register"]');

                                  if (siblingLinks.length === 0) {
                                      for (const sibling of formSiblings) {
                                          if (sibling !== loginForm && sibling.matches('a[href$="/account/register"]')) {
                                              foundLink = sibling;
                                              break;
                                          }
                                      }
                                      selector_wsf = foundLink;
                                  } else {
                                      selector_wsf = siblingLinks[0];
                                  }
                              }
                          }
                          if (selector_wsf && document.querySelectorAll('.wsaio_form').length === 0) {
                              const newLinkHTML = '<br><a href="' + WSAIO.create_wholesale_account_link + '" class="wsaio_form">' + WSAIO.create_wholesale_account_link_label + '</a>';
                              selector_wsf.insertAdjacentHTML('afterend', newLinkHTML);
                          }
                    
                        }else{
                            const el6 = document.querySelectorAll(WSAIO.default_create_account_selector);
                            const htmlContent6 = '<br><a href="' + WSAIO.create_wholesale_account_link + '" class="wsaio_form">' + WSAIO.create_wholesale_account_link_label + '</a>';
                            el6.forEach(function(targetElement) {
                              if(document.querySelectorAll('.wsaio_form').length === 0){
                                targetElement.insertAdjacentHTML('afterend', htmlContent6);
                              }
                            });
                        }
                  }
            if(WSAIO.wholesale_signup_link_on_login_page == 'replace'){
                document.querySelectorAll('a[href$="/account/register"]').forEach(function(element) {
                    element.style.cssText = 'display: none !important;';
                });
                append_link();
                const NewSignupPageLink = WSAIO.create_wholesale_account_link;
                document.querySelectorAll('a[href$="/account/register"]').forEach(function(element) {
                    element.addEventListener("click", function(e) {
                        e.preventDefault();
                        window.location.href = NewSignupPageLink;
                    });
                });
                if(window.location.pathname == WSAIO.local_param+"account/register"){
                  window.location.href = NewSignupPageLink;
                }
            }
            else if(  WSAIO.wholesale_signup_link_on_login_page == 'append'){
              append_link();
            }
          }
}

// ----------------------

WSAIO.cart_qty_handler_define = function(){
   window.HandlecartQty=function(){
        var init_module=function(){}
        return {
        init:init_module
        }
    }()
    HandlecartQty.init();
        WSAIO.cart_qty_change_event = function(){
           if(typeof WSAIO.Auto_free_theme != 'undefined' && WSAIO.Auto_free_theme) return false;
            if( window.wsaio_involved != undefined && window.wsaio_involved == true && WSAIO.app_mode_applied && typeof window.token_enable == 'undefined'){
              const quantityChangeHandler = () => {
                  setTimeout(function() {
                      if (typeof WSAIO.checkoutEventListner === 'function') {
                          WSAIO.checkoutEventListner();
                      } 
                      WSAIO.preCheckout();
                  }, WSAIO.qty_change_delay);
              };
              document.addEventListener('click', function(e) {
                  if (e.target.closest(WSAIO.cart_qty_btn_selector)) {
                      quantityChangeHandler();
                  }
              });
              document.addEventListener('change', function(e) {
                  if (e.target.matches(WSAIO.cart_qty_input_selector)) {
                      quantityChangeHandler();
                  }
              });

              document.addEventListener('keyup', function(e) {
                  if (e.target.matches(WSAIO.cart_qty_input_selector)) {
                      const selectors = WSAIO.checkout_selector + ',' + WSAIO.duplicate_checkout_selector + ',' + WSAIO.netTerm_checkout_selector;
                      
                      document.querySelectorAll(selectors).forEach(element => {
                          element.classList.add('wsaio_hideCheckout');
                      });
                  }
              });
            }
        }
}

// ------------------------

WSAIO.MOQ_function = function(params){
 if(WSAIO.qtyControl != undefined){
		    var price_selector;
			var parent_selector = WSAIO.product_parent_grid_selector;
			if (typeof params.item_price_selector === 'string') {
				price_selector = document.querySelector(params.item_price_selector);
			}else{
				price_selector = params.item_price_selector;
			}
			if(price_selector != null){
				window.selected_variant_id = params.variant_id;
				WSAIO.qtyControl({
						template: params.template,
						item_price_selector: price_selector,
						product: current_product,
						productId: current_product.id,
						variantId: params.variant_id,
						functionality: 'variant_level',
						add_to_cart: WSAIO.default_atc_selector,
						parent_product_selector: parent_selector ,
						removeableSelector_qty: WSAIO.default_qty_selector,
						removeableSelector_variants: WSAIO.Default_variant_selector
					});
			}
	  }
}


// -------------- app enable preview bar ---------------

WSAIO.app_enable_preview_define = function(){
   if(!WSAIO.removeQueryString){
    WSAIO.removeQueryString = function(m, k) {
      var r = document.location.href, u = location.search;
      "" != m ? (k = encodeURIComponent(k), m = m + "=" + k, "-1" != u.indexOf("?" + m + "&") ? r = r.replace("?" + m + "&", "?") : "-1" != u.indexOf("&" + m + "&") ? r = r.replace("&" + m + "&", "&") : "-1" != u.indexOf("?" + m) ? r = r.replace("?" + m, "") : "-1" != u.indexOf("&" + m) && (r = r.replace("&" + m, ""))) : (u = location.search, r = r.replace(u, ""));
      history.pushState({state:1, rand:Math.random()}, "", r);
    };
  }
  if(!WSAIO.getParameterByName){
    WSAIO.getParameterByName = function(m) {
      for (var k = [], r = window.location.search.substring(1).split("&"), u = 0; u < r.length; u++) {
        var a = r[u].split("=");
        a[0] == m && k.push(decodeURIComponent(a[1]));
      }
      return k;
    };
  }
  if(!window.wsaioClosePreview){
    window.wsaioClosePreview = function() {
      WSAIO.removeQueryString("test-mode", WSAIO.getParameterByName("test-mode")[0]);
      localStorage.removeItem("wsaio-app-mode");
      WSAIO.user_mode = "live";
      setTimeout(function() {
        window.location.href = "https://" + Shopify.shop;
      }, 500);
    };
  }
  if(!window.wsaioHidePreview){
    window.wsaioHidePreview = function() {
      document.querySelectorAll(".wholesaleAllInOnePreview").forEach(element => {
          element.remove();
      });
      document.documentElement.style.paddingBottom = '';
    };
  }
  if(!WSAIO.addPreviewBar){
    WSAIO.addPreviewBar = function() {
        const previewExists = document.querySelectorAll(".wholesaleAllInOnePreview").length > 0;

        if (!previewExists) {
            const htmlContent = '<div class="wholesaleAllInOnePreview"> <div class="wholesale_bar__stack"> <div class="wholesale_bar__item"> <div> <strong style="font-weight: 600 !important;">Wholesale All In One Preview: </strong> Wholesale pricing are only visible to you. <a href="https://support.digitalcoo.com/hc/en-us/articles/360042800512"><u>Learn More</u></a> </div> </div> <div> <div class="wsaio_bar_dropdown" style="display:none;"> <button onclick="WSAIO.wsaio_actions()" class="wsaio_bar_dropbtn wholesale-button-group">Actions <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width: 16px !important; position: absolute !important; right: 15px !important;top: 11px !important;"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path></svg></button> <div id="wsaio_bar_myDropdown" class="wsaio_bar_dropdown-content" style="background: white !important;"> <button class="wsaio_bar_btn wholesale-button-group" onclick="wsaioClosePreview();" type="button" name="button" style="color: #212b36 !important;border: none !important;border-bottom: 1px solid #80808038 !important; border-radius: unset !important;">Close preview</button> <button class="wholesale-button-group wsaio_bar_btn  wholesale-button-group2" onclick="wsaioHidePreview();" type="button" name="button" style="color:#007ace !important">Hide bar</button> </div> </div> </div> <ul class="wholesale_bar__button_group"> <li class="wholesale-button-group__item"> <button class="wholesale-button-group" onclick="wsaioClosePreview();" type="button" name="button" style="color: #212b36;">Close preview</button> <li class="wholesale-button-group__item"> <button class="wholesale-button-group wholesale-button-group2" onclick="wsaioHidePreview();" type="button" name="button" style="color:#007ace !important;">Hide bar</button> </li> </ul> </div> </div>';
            document.body.insertAdjacentHTML('beforeend', htmlContent);
        }
        document.documentElement.style.paddingBottom = "60px";
    };
  }
     
  "undefined" !== typeof WSAIO.getParameterByName("test-mode")[0] && (WSAIO.user_mode = "test", localStorage.setItem("wsaio-app-mode", "test"), WSAIO.addPreviewBar());
  null !== localStorage.getItem("wsaio-app-mode") && WSAIO.addPreviewBar();
      WSAIO.app_mode = WSAIO.general_settings.app_mode || "live";
    WSAIO.user_mode = localStorage.getItem("wsaio-app-mode") || "live";
     WSAIO.app_mode_applied = false;
    if(WSAIO.app_mode == 'live'){
      if(WSAIO.user_mode == 'test' || WSAIO.user_mode == 'live'){
       WSAIO.app_mode_applied = true;
    }
    }else if(WSAIO.app_mode == 'test'){
        if(WSAIO.user_mode == 'test'){
        WSAIO.app_mode_applied = true;
        }
    }
    WSAIO.wsaio_actions =  function() {
       document.getElementById("wsaio_bar_myDropdown").classList.toggle("wsaio_bar_show");
     }
     window.onclick = function(event) {
       if (!event.target.matches('.wsaio_bar_dropbtn')) {
         var dropdowns = document.getElementsByClassName("wsaio_bar_dropdown-content");
         var i;
         for (i = 0; i < dropdowns.length; i++) {
           var openDropdown = dropdowns[i];
           if (openDropdown.classList.contains('wsaio_bar_show')) {
             openDropdown.classList.remove('wsaio_bar_show');
           }
         }
       }
     }
}

// ---------------- QOF_links append on account page--------------
  
WSAIO.QOF_links_append = function(){
  if(WSAIO.app_mode_applied && typeof WSAIO.QOF_links != 'undefined' && WSAIO.QOF_links.length){
          const selectorQofList = document.querySelectorAll(WSAIO.default_qof_link_selector);
          if (selectorQofList.length > 0) {
              if (typeof window.location !== 'undefined' && typeof window.location.pathname !== 'undefined') {
                  if (window.location.pathname.includes('/account')) {
                      selectorQofList.forEach(selector_qof => {
                          if (typeof WSAIO.qof_navigation_enable !== 'undefined' && WSAIO.qof_navigation_enable) {
                              const linkHtml = '<br><a href="' + WSAIO.local_param + WSAIO.QOF_links[0].page_link + '" class="wsaio_qof_form">' + WSAIO.QOF_links[0].title + '</a>';
                              selector_qof.insertAdjacentHTML('afterend', linkHtml);
                          } else {
                              let links_option = '';
                              for (let i = 0; i < WSAIO.QOF_links.length; i++) {
                                  links_option += ' <tr style="padding: 10px !important;display: block;border-top: 1px solid #dddddd63 !important;" redirect_link="' + WSAIO.local_param + WSAIO.QOF_links[i].page_link + '" class="redirect_to_qof"><td style="padding:0px !important;display: block !important;border: none !important;"><a href="#" class="wsaio_qof_form" style="padding: 5px 28px !important;text-decoration: underline !important;display:block;text-align: center !important;border: none !important; box-shadow: none !important;font-size: 12px; width: fit-content;">' + WSAIO.QOF_links[i].title + '</a></td></tr>';
                              }
                              if (document.querySelectorAll('.qof_links_dropdown').length === 0) {
                                  const tableHtml = '<table class="qof_links_dropdown" style="margin-top: 15px;cursor: pointer;border: 1px solid  #dddddd63 !important; width: fit-content !important; padding: 10px 0px; box-shadow: none !important;    border-top: none !important;"><tbody>' + links_option + '</tbody></table>';
                                  selector_qof.insertAdjacentHTML('afterend', tableHtml);
                              }
                              document.addEventListener('click', function(e) {
                                  const targetRow = e.target.closest('.redirect_to_qof');
                                  if (targetRow) {
                                      const redirectLink = targetRow.getAttribute('redirect_link');
                                      if (redirectLink) {
                                          window.location.href = redirectLink;
                                      }
                                  }
                              });
                          }
                      });
                  }
              }
          }
  }
}

// ---------------- Buy noew define --------------

WSAIO.buy_now_define = function() {
    if (window.wsaio_involved !== undefined && window.wsaio_involved === true && WSAIO.app_mode_applied && typeof WSAIO.buyNowEventListener === "undefined") {
        WSAIO.buy_it_now = function() {
            document.addEventListener('click', function(event) {
                const button = event.target.closest(WSAIO.buy_now_button_selector);
                if (!button) {
                    return;
                }

                event.preventDefault();
                event.stopImmediatePropagation();
                button.disabled = true;

                var form = button.closest("form");

                const productParent = form ? form.closest(WSAIO.product_parent_grid_selector) : null;
                
                const findAndGet = (selector, type) => {
                    const el = productParent ? productParent.querySelector(selector) : null;
                    if (el) {
                        return type === 'val' ? el.value : el.getAttribute('data-handle');
                    }
                    return null;
                };

                var product_handle = findAndGet('[name="id"][data-handle]', 'data-handle') || (typeof current_product !== 'undefined' ? current_product.handle : null),
                    variant_id = findAndGet('[name="id"]', 'val'),
                    product_quantity = findAndGet('[name="quantity"]', 'val');
                    
                variant_id = variant_id ? String(variant_id) : null;
                product_quantity = product_quantity ? Number(product_quantity) : null;

                if (product_quantity === undefined || product_quantity === null) {
                    product_quantity = 1;
                }

                var variant_inventory_info = {};
                var inventory_issue = false;
                var available_qty = 0;

                if (typeof WSAIO.default_product_variant !== 'undefined' && WSAIO.default_product_variant.length > 0) {
                    variant_inventory_info = WSAIO.default_product_variant.find(function(e) {
                        return String(e.variant_id) === variant_id; // Ensure comparison is safe
                    });
                }
                if (!variant_inventory_info) variant_inventory_info = {};

                if (variant_inventory_info && Object.keys(variant_inventory_info).length) {
                    if (variant_inventory_info.variant_inventory_management !== undefined && variant_inventory_info.variant_inventory_management !== '') {
                        if (variant_inventory_info.variant_inventory_policy === 'deny') {
                            if (parseInt(product_quantity) > parseInt(variant_inventory_info.variant_inventory_quantity)) {
                                inventory_issue = true;
                                available_qty = variant_inventory_info.variant_inventory_quantity;
                            }
                        }
                    }
                }

                if (inventory_issue) {
                    button.disabled = false;
                    if (document.querySelectorAll('.waioBUY_inventory_error').length === 0) {
                        document.querySelectorAll('.waioBUY_inventory_error').forEach(el => el.remove());
                        const paymentWrapper = productParent ? productParent.querySelector(WSAIO.shopify_payment_button_wrapper) : null;
                        if (paymentWrapper) {
                             paymentWrapper.insertAdjacentHTML('afterend', '<p class="waioBUY_inventory_error" style="font-size: 14px;color:red;">Only ' + available_qty + ' item(s) are available. Please update the quantity and try again.</p>');
                        }
                    }
                    setTimeout(function() {
                        document.querySelectorAll('.waioBUY_inventory_error').forEach(el => el.remove());
                    }, 4000);
                    return false;
                }

                WSAIO.getProduct(product_handle, function(pr) {
                    WSAIO.buy_now_product = pr;
                    proccedToBuyItNow();
                });

                function proccedToBuyItNow() {
                    if (typeof WSAIO.buy_now_product !== 'undefined' && WSAIO.buy_now_product !== null) {
                        var product = WSAIO.buy_now_product;
                        if (product) {
                            var selected_variant_index = product.variants.findIndex(function(a) {
                                return String(a.id) === variant_id;
                            }),
                                variant = {};
                            if (-1 < selected_variant_index) {
                                variant = product.variants[selected_variant_index];
                            }
                            if (typeof MOQ_applied !== 'undefined' && MOQ_applied.length > 0) {
                                if ((Number(product_quantity) % MOQ_applied[0]._qtyInc) === 0 && Number(product_quantity) >= MOQ_applied[0]._qtyMin) {
                                    if (MOQ_applied[0]._qtyMax !== 0 && Number(product_quantity) <= MOQ_applied[0]._qtyMax) {
                                        document.querySelectorAll(WSAIO.buy_now_button_selector).forEach(el => {
                                            el.classList.remove('checkout-disabled');
                                            el.removeAttribute('disabled');
                                        });
                                        WSAIO.disable_buy_now_button_moq = false;
                                    } else {
                                        document.querySelectorAll(WSAIO.buy_now_button_selector).forEach(el => {
                                            el.classList.remove('checkout-disabled');
                                            el.removeAttribute('disabled');
                                        });
                                        WSAIO.disable_buy_now_button_moq = false;
                                    }
                                } else {
                                    if (WSAIO.buyNow_message !== '') {
                                        const paymentWrapper = productParent ? productParent.querySelector(WSAIO.shopify_payment_button_wrapper) : null;
                                        if (paymentWrapper) {
                                            paymentWrapper.insertAdjacentHTML('afterend', '<p class="waioMOQ_buy_message" style="font-size: 14px;">Minimum Requirements not fulfilled</p>');
                                        }
                                    }
                                    document.querySelectorAll(WSAIO.buy_now_button_selector).forEach(el => {
                                        el.classList.add('checkout-disabled');
                                        el.setAttribute('disabled', 'disabled');
                                    });
                                    WSAIO.disable_buy_now_button_moq = true;

                                    setTimeout(function() {
                                        document.querySelectorAll(WSAIO.buy_now_button_selector).forEach(el => {
                                            el.classList.remove('checkout-disabled');
                                            el.removeAttribute('disabled');
                                        });
                                        document.querySelectorAll('.waio_buy_message, .waioMOQ_buy_message').forEach(el => el.remove());
                                    }, 2500);
                                }
                            }

                            setTimeout(function() {
                                if (current_product && current_product.id) {
                                    const selector = '.wsaio_' + current_product.id;
                                    document.querySelectorAll(selector).forEach(priceEl => {
                                        const parentGrid = priceEl.closest(WSAIO.product_parent_grid_selector);
                                        if (parentGrid) {
                                            const buyNowEl = parentGrid.querySelector('.wsaio_buynow');
                                            if (buyNowEl) {
                                                buyNowEl.style.cssText = 'display:inline-block !important';
                                            }
                                        }
                                    });
                                }
                            }, 10);

                            WSAIO.BuyNoworderControl(Number(variant.price), Number(product_quantity), WSAIO.buy_now_button_selector, [], Number(variant.price));

                            if (WSAIO.disable_buy_now_button || WSAIO.disable_buy_now_button_moq) {
                                return false;
                            } else {
                                return window.location.href = WSAIO.local_param + 'cart/' + variant_id + ':' + product_quantity;
                            }
                        }
                    }
                }
            });
        };
        WSAIO.getProduct = function(handle, callback) {
            fetch(WSAIO.local_param + 'products/' + handle + '.js')
                .then(response => response.json())
                .then(product => {
                    if (typeof callback === "function") {
                        callback(product);
                    }
                })
                .catch(error => console.error('Error fetching product:', error));

            return "Use callback function to get product";
        };

        WSAIO.addBuyNowBtnHTML = function() {
            var is_replace = false;
            if (WSAIO.buy_now_btn_replace) {
                is_replace = true;
            }
            if ((WSAIO.subscription_variant_selector !== '' || WSAIO.subscription_variant_selector !== 'false') && WSAIO.buy_now_btn_replace) {
                const subscriptionEl = document.querySelector(WSAIO.subscription_variant_selector);
                if (subscriptionEl && subscriptionEl.checked) { 
                    is_replace = false;
                } else {
                    is_replace = true;
                }
            }
            var is_append = setInterval(function() {
                if (typeof current_product !== 'undefined' && current_product !== null) {
                    const priceSelector = WSAIO.product_price_selector;
                    const priceClass = 'wsaio_' + current_product.id;
                    document.querySelectorAll(priceSelector).forEach(el => el.classList.add(priceClass));
                    
                    const selector = '.' + priceClass;

                    const findInParentGrid = (innerSelector) => {
                         const priceEl = document.querySelector(selector);
                         const parentGrid = priceEl ? priceEl.closest(WSAIO.product_parent_grid_selector) : null;
                         return parentGrid ? parentGrid.querySelector(innerSelector) : null;
                    };
                    
                    const findAllInParentGrid = (innerSelector) => {
                         const priceEl = document.querySelector(selector);
                         const parentGrid = priceEl ? priceEl.closest(WSAIO.product_parent_grid_selector) : null;
                         return parentGrid ? parentGrid.querySelectorAll(innerSelector) : [];
                    };
                    if (is_replace === false) {
                        findAllInParentGrid('.wsaio_buynow').forEach(el => el.remove());
                    }
                    const paymentWrapper = findInParentGrid(WSAIO.shopify_payment_button_wrapper);
                    const buyNowButton = paymentWrapper ? paymentWrapper.querySelector(WSAIO.buy_now_button_selector) : null;

                    if (buyNowButton) {
                        if (paymentWrapper) paymentWrapper.style.display = 'none';
                        const existingBuyNow = findAllInParentGrid('.wsaio_buynow');

                        if (existingBuyNow.length === 0 && is_replace) {
                            const hideAndStyle = (el) => {
                                el.classList.add('wsaio_hide_btn');
                                el.style.cssText = 'display:none !important';
                            };
                            hideAndStyle(buyNowButton);
                            const moreOptions = paymentWrapper.querySelector('.shopify-payment-button__more-options');
                            if (moreOptions) hideAndStyle(moreOptions);
                            if (paymentWrapper) paymentWrapper.insertAdjacentHTML('beforeend', WSAIO.buy_now_button_html);
                            const newBuyNow = findInParentGrid('.wsaio_buynow');
                            if (newBuyNow) newBuyNow.style.cssText = 'display:inline-block !important';
                            
                        } else {
                            if (WSAIO.buy_now_btn_replace === false || is_replace === false) {
                                document.querySelectorAll(WSAIO.product_parent_grid_selector + ' .wsaio_buynow').forEach(el => el.remove());
                                const restoreStyle = (el) => {
                                    el.classList.remove('wsaio_hide_btn');
                                    el.style.cssText = ''; 
                                };

                                if(buyNowButton) restoreStyle(buyNowButton);
                                const moreOptions = paymentWrapper ? paymentWrapper.querySelector('.shopify-payment-button__more-options') : null;
                                if (moreOptions) restoreStyle(moreOptions);

                                document.querySelectorAll('.shopify-payment-button .shopify-payment-button__button').forEach(el => el.style.cssText = 'display:inline-block !important');
                            }
                        }

                        WSAIO.buy_it_now();

                        if (typeof WSAIO.showBuy !== 'undefined') {
                            WSAIO.showBuy();
                        }
                        
                        if (findAllInParentGrid('.wsaio_buynow').length !== 0) {
                             const hideAndStyle = (el) => {
                                el.classList.add('wsaio_hide_btn');
                                el.style.cssText = 'display:none !important';
                            };

                            const buttonSiblings = paymentWrapper ? paymentWrapper.querySelectorAll('button + div ' + WSAIO.buy_now_button_selector) : [];
                            const buttonSiblingsOtherButton = paymentWrapper ? paymentWrapper.querySelectorAll('button + div ' + WSAIO.buy_now_button_selector + ' ~ button') : [];
                            
                            buttonSiblings.forEach(hideAndStyle);
                            buttonSiblingsOtherButton.forEach(hideAndStyle);
                        }

                        clearInterval(is_append);

                    }
                } else {
                    clearInterval(is_append);
                }
            }, 100);
        };
        document.addEventListener('DOMContentLoaded', function() {
            setTimeout(function() {
                WSAIO.buyNowEventListener = function() {
                    WSAIO.addBuyNowBtnHTML();
                };
                setTimeout(function() {
                    try {
                        if (current_product && current_product.id) {
                            const priceEl = document.querySelector('.wsaio_' + current_product.id);
                            const parentGrid = priceEl ? priceEl.closest(WSAIO.product_parent_grid_selector) : null;
                            const paymentWrapper = parentGrid ? parentGrid.querySelector(WSAIO.shopify_payment_button_wrapper) : null;
                            if (paymentWrapper) paymentWrapper.style.display = '';
                        }
                    } catch (e) {}
                    WSAIO.showBuyevent = function() {
                        WSAIO.showBuy = function() {
                            if (current_product && current_product.id) {
                                const priceEl = document.querySelector('.wsaio_' + current_product.id);
                                const parentGrid = priceEl ? priceEl.closest(WSAIO.product_parent_grid_selector) : null;
                                const paymentWrapper = parentGrid ? parentGrid.querySelector(WSAIO.shopify_payment_button_wrapper) : null;
                                if (paymentWrapper) paymentWrapper.style.display = '';
                            }
                        };
                    };
                    if (typeof WSAIO.showBuyevent !== 'undefined') {
                        WSAIO.showBuyevent();
                    }
                }, 500);
            }, 5000);
        });

        WSAIO.buyNowEventListener = function() {
            WSAIO.addBuyNowBtnHTML();
        };
    }
};

//---------------- Cart Level UpSell message -------------

WSAIO.cartLevelUpSell = function () {
  if(typeof WSAIO.show_cart_level_upsell_message != 'undefined' && WSAIO.show_cart_level_upsell_message){
      WSAIO.wsaioUpSell_msg = '';
      WSAIO.cartLevelUpSell_applied = [];
      var cart_subtotal_value = parseFloat(WSAIO.discount_response.checkout_price_from_items_subtotal_price);
      var cart_quantity = parseInt(cart_data.item_count);
      var upsell_msg_condition = [];
      var is_cld = false;
      if (WSAIO.cart_ld_discounts && WSAIO.cart_ld_discounts.length) {
            // filter applied rule
            for (var cld_index = 0; cld_index < WSAIO.cart_ld_discounts.length; cld_index++) {
              var rule_item = WSAIO.cart_ld_discounts[cld_index];
              if (rule_item.state != 'published') continue;
              if (WSAIO.checkCustomer(rule_item.customer_group, rule_item.tags, rule_item.tags_excluded)){
                WSAIO.cartLevelUpSell_applied.push(rule_item);
              }
            }
            // set priority value based on customer_group
            for (var cld_index2 = 0; cld_index2 < WSAIO.cartLevelUpSell_applied.length; cld_index2++) {
                 var single_rule = WSAIO.cartLevelUpSell_applied[cld_index2];
                 if(single_rule.customer_group == 'has_tag'){
                     WSAIO.cartLevelUpSell_applied[cld_index2].priority = 1;
                 }else if(single_rule.customer_group == 'has_account'){
                     WSAIO.cartLevelUpSell_applied[cld_index2].priority = 2;
                 }else if(single_rule.customer_group == 'all'){
                     WSAIO.cartLevelUpSell_applied[cld_index2].priority = 3;
                 }
            }
    
            WSAIO.cartLevelUpSell_applied.sort(function(a, b){
                  if(a.priority < b.priority) { return 1; }
                  if(a.priority > b.priority) { return -1; }
                  return 0;
           })
          
          for (var cld_index3 = 0; cld_index3 < WSAIO.cartLevelUpSell_applied.length; cld_index3++) {
                var single_rule = WSAIO.cartLevelUpSell_applied[cld_index3];
                     switch(single_rule.customer_group) {
                        case 'all':
                                  for (var i = 0; i < single_rule.discounts.length; i++) {
                                  if(single_rule.calculation_type == 'cart_quantity'){
                                      if(cart_quantity < single_rule.discounts[i].value){
                                          single_rule.discounts[i].type = 'item';
                                           upsell_msg_condition.find(function(e,r){ if(typeof e != 'undefined' && e.type == 'item'){ upsell_msg_condition.splice(r,1)  }})
                                          upsell_msg_condition.push(single_rule.discounts[i]);
                                          break;
                                      }
                                  }else{
                                       if(cart_subtotal_value < single_rule.discounts[i].value){
                                          single_rule.discounts[i].type = 'subtotal';
                                            upsell_msg_condition.find(function(e,r){ if(typeof e != 'undefined' && e.type == 'subtotal'){ upsell_msg_condition.splice(r,1)  }})
                                          upsell_msg_condition.push(single_rule.discounts[i]);
                                          break;
                                      }
                                  }
                              }
                          break;
                        case 'has_account':
                                 for (var i = 0; i < single_rule.discounts.length; i++) {
                                  if(single_rule.calculation_type == 'cart_quantity'){
                                      if(cart_quantity < single_rule.discounts[i].value){
                                          single_rule.discounts[i].type = 'item';
                                           upsell_msg_condition.find(function(e,r){ if(typeof e != 'undefined' && e.type == 'item'){ upsell_msg_condition.splice(r,1)  }})
                                         upsell_msg_condition.push(single_rule.discounts[i]);
                                          break;
                                      }
                                  }else{
                                       if(cart_subtotal_value < single_rule.discounts[i].value ){
                                          single_rule.discounts[i].type = 'subtotal';
                                          upsell_msg_condition.find(function(e,r){ if(typeof e != 'undefined' && e.type == 'subtotal'){ upsell_msg_condition.splice(r,1)  }})
                                          upsell_msg_condition.push(single_rule.discounts[i]);
                                          break;
                                      }
                                  }
                              }
                          break;
                        default:
                             for (var i = 0; i < single_rule.discounts.length; i++) {
                                  if(single_rule.calculation_type == 'cart_quantity'){
                                      if(cart_quantity < single_rule.discounts[i].value){
                                          single_rule.discounts[i].type = 'item';
                                          upsell_msg_condition.find(function(e,r){if(typeof e != 'undefined' && e.type == 'item'){ upsell_msg_condition.splice(r,1)  }})
                                          upsell_msg_condition.push(single_rule.discounts[i]);
                                          break;
                                      }
                                  }else{
                                       if(cart_subtotal_value < single_rule.discounts[i].value){
                                           single_rule.discounts[i].type = 'subtotal';
                                           upsell_msg_condition.find(function(e,r){ if(typeof e != 'undefined' && e.type == 'subtotal'){ upsell_msg_condition.splice(r,1)  }})
                                           upsell_msg_condition.push(single_rule.discounts[i]);
                                          break;
                                      }
                                  }
                              }
                      }
        }
        for (var ij = 0; ij < upsell_msg_condition.length; ij++) {
            if(upsell_msg_condition[ij].type == 'subtotal'){
                WSAIO.wsaioUpSell_msg = WSAIO.wsaioUpSell_msg + "<li style='display: flex !important;'><span style='text-align: left !important; padding-left: 10px !important;'>You're "+WSAIO.formatMoney(upsell_msg_condition[ij].value-cart_subtotal_value)+" away from getting "+upsell_msg_condition[ij].discount_value+"% discount</span></li>";
            }else{
                WSAIO.wsaioUpSell_msg = WSAIO.wsaioUpSell_msg + "<li style='display: flex !important;'><span style='text-align: left !important; padding-left: 10px !important;'>Only "+(upsell_msg_condition[ij].value-cart_quantity)+" cart item left from getting "+upsell_msg_condition[ij].discount_value+"% discount</span></li>";
            }
        }
    }
  }
}

window.addEventListener("load", function() {
    setTimeout(function() {
        const netMobileDivs = document.querySelectorAll('.new_net_mobile_div');

        if (netMobileDivs.length !== 0) {
            try {
                document.querySelectorAll('.NetTerm_div').forEach(netTermDiv => {
                    netTermDiv.querySelectorAll('input[type="submit"]').forEach(submitInput => {
                        const form = submitInput.closest('form');
                        if (form) {
                            form.addEventListener('submit', function(e) {
                                e.preventDefault(); 
                                e.stopImmediatePropagation(); 
                            }, { once: true, capture: true }); 
                        }
                    });
                });
            } catch (e) {
            }
        }
    }, 200);
});

}

/* -----------------------CALL MODULE (Start)------------------------------ */
if(typeof window.WSAIO_MODULE !== "undefined"){
      var jQ = typeof window.WSAIO_GET_JQUERY === "function" ? window.WSAIO_GET_JQUERY() : jQuery;
      if(jQ){
        window.WSAIO_MODULEJS(jQ);
        window.WSAIO_MODULE(jQ);
  }else{
        window.WSAIO_MODULEJS();
      window.WSAIO_MODULE();
  }
};
/* -----------------------CALL MODULE (End)------------------------------ */

if(typeof WSAIO.app_enable_preview_define != 'undefined')WSAIO.app_enable_preview_define();

/* -----------------------CALL MODULE (Start)------------------------------ */
if(typeof window.WSAIO_MODULEJS !== "undefined"){
      WSAIO.disable_checkout = false;

    function disable_checkout(a, b, d) { WSAIO.disable_checkout_define(a, b, d);  }        
    function minOrderControl() {  WSAIO.minOrderControl_define();  }
    WSAIO.order_control = function(){if(WSAIO.cart_qty_btn_selector != 'blank' && WSAIO.cart_qty_input_selector != 'blank' && WSAIO.app_mode_applied){minOrderControl()}};
    WSAIO.disableCheckout = function(c,m,el){if(WSAIO.cart_qty_btn_selector != 'blank' && WSAIO.cart_qty_input_selector  != 'blank' && WSAIO.app_mode_applied){disable_checkout(c,m,el)}};
    if(typeof WSAIO.fetchCart_define != 'undefined')WSAIO.fetchCart_define();          
    if(typeof WSAIO.QOF_links_append != 'undefined') WSAIO.QOF_links_append();      
    if(typeof WSAIO.ROF_link_append != 'undefined') WSAIO.ROF_link_append();    
     if(typeof WSAIO.buy_now_define != 'undefined')WSAIO.buy_now_define();
         /* Star Code for Quantity change detector */
    if(typeof WSAIO.cart_qty_handler_define != 'undefined')WSAIO.cart_qty_handler_define();
    
    

   WSAIO.showCheckoutLoader = function() {
        if(typeof WSAIO.app_mode_applied != 'undefined' && WSAIO.app_mode_applied){
        document.querySelectorAll('.wsaio_loader').forEach(element => {
            element.remove();
        });
        const checkoutSelectors = WSAIO.checkout_selector + ',' + WSAIO.duplicate_checkout_selector;
        const el8 = document.querySelectorAll(checkoutSelectors);
        
        el8.forEach(element => {
            element.classList.add('wsaio_hideCheckout');
        });
        const loaderHTML = '<div class="wsaio_loader_checkout wsaio_loader"> <div class="loading-spinner"></div> </div>';
        el8.forEach(element => {
            element.insertAdjacentHTML('afterend', loaderHTML);
        });
        }
    };

    if( window.wsaio_involved != undefined && window.wsaio_involved == true && WSAIO.app_mode_applied){  WSAIO.showCheckoutLoader() }   
      
        window.addEventListener("load", function(){
            if(typeof WSAIO != 'undefined'){
              if(typeof WSAIO.loginLink != 'undefined') WSAIO.loginLink();
                if(typeof window.ZapietCheckoutEnabled != 'undefined'){
                   var valid_chk = false;
                   setInterval(function(){
                      if(window.ZapietCheckoutEnabled && valid_chk == false){ 
                        if(typeof WSAIO.checkoutEventListner != 'undefined'){WSAIO.checkoutEventListner()}
                        valid_chk =true;                                   
                      }else if(!window.ZapietCheckoutEnabled && valid_chk == true){ 
                        valid_chk =false; 
                      }
                    },100)
                }

               if(typeof window.token_enable != 'undefined' && window.token_enable == true){
                  const regularPriceItems = document.querySelectorAll('.quick-add-modal__content--bulk .price-item--regular');
                  regularPriceItems.forEach(initialElement => {
                      const priceSaleParent = initialElement.closest('.price__sale');
                      if (priceSaleParent) {
                          const siblingRegularPrice = Array.from(priceSaleParent.parentNode.children).find(
                              sibling => sibling !== priceSaleParent && sibling.classList.contains('price__regular')
                          );

                          if (siblingRegularPrice) {
                              const targetPriceElement = siblingRegularPrice.querySelector('.price-item--regular');

                              if (targetPriceElement) {
                                  targetTargetPriceElement.style.display = 'none';
                              }
                          }
                      }
                  });
               }


               if(typeof current_product != 'undefined' && current_product != null){
                  const startSelector = '.wsaio_' + current_product.id;
                  document.querySelectorAll(startSelector).forEach(initialElement => {
                      const productParent2 = initialElement.closest(WSAIO.product_parent_grid_selector);

                      if (productParent2) {
                          const buyNowElement = productParent2.querySelector('.wsaio_buynow');

                          if (buyNowElement) {
                              buyNowElement.style.cssText = 'display:inline-block !important';
                          }
                      }
                  });
                }

               try{WSAIO.buyNowEventListener()}catch(e){}
                if( window.wsaio_involved != undefined && window.wsaio_involved == true && WSAIO.app_mode_applied){
                 WSAIO.cart_qty_change_event();
              }
                setTimeout(function(){
                     if((typeof WSAIO != 'undefined' && typeof WSAIO.cartDrawer === 'function' && WSAIO.template === "cart") || (typeof WSAIO != 'undefined' && window.location.pathname.indexOf('pages/net-term-order') > -1 )){
                        if(!!WSAIO.discount_response && (Array.isArray(WSAIO.discount_response) ? WSAIO.discount_response.length > 0 : Object.keys(WSAIO.discount_response).length > 0)){
                          WSAIO.preCheckoutResponse(WSAIO.discount_response)
                          WSAIO.callback(WSAIO.discount_response)
                          if(typeof WSAIO.loadcartQuantityControllers != 'undefined' && typeof WSAIO.load_checkout_restriction != 'undefined'){ WSAIO.load_checkout_restriction(); WSAIO.loadcartQuantityControllers([],function(e){WSAIO.run_checkout()});}else{WSAIO.run_checkout()}
                        }else{
                          WSAIO.preCheckout();
                        }
                      }
                      if(WSAIO.agreement_checkout_selector != '' && document.querySelectorAll(WSAIO.agreement_checkout_selector).length !== 0 && window.wsaio_involved != undefined && window.wsaio_involved == true && WSAIO.app_mode_applied){
                          if(document.querySelector(WSAIO.agreement_checkout_selector)?.checked){
                            window.isAgree = true;
                            WSAIO.run_checkout()
                          }else{
                            window.isAgree = false;
                            WSAIO.run_checkout()
                          }
                         document.addEventListener('click', function(e) {
                            const el9 = e.target.closest(WSAIO.agreement_checkout_selector);
                            if (el9) {
                                if (el9.checked) {
                                    window.isAgree = true;
                                    WSAIO.run_checkout();
                                } else {
                                    window.isAgree = false;
                                    WSAIO.run_checkout();
                                }
                            }
                        });
                      }

          
                     setTimeout(function(){
                          /* ----------for without login show checkout -------------- */
                        try{
                              function show_checkout(){
                                  const checkoutSelectors = WSAIO.checkout_selector + ',' + WSAIO.duplicate_checkout_selector;
                                      const checkoutSelectorssel2 = checkoutSelectors.split(',');
                                      const cleanSelectorssel2 = checkoutSelectorssel2.map(sel => sel.trim()).filter(Boolean);
                                      document.querySelectorAll(cleanSelectorssel2).forEach(element => {
                                          element.classList.remove('wsaio_hideCheckout');
                                      });
                                      const couponSelectors = '.wsaio_coupon_group, .wsaio_coupon_link';
                                      document.querySelectorAll(couponSelectors).forEach(element => {
                                          element.style.cssText = 'display:block !important';
                                      });
                              }
                            
                              if(WSAIO != undefined && !WSAIO.main_liquid_file_included && (typeof WSAIO.isShowCheckout == 'undefined')){
                                  show_checkout();
                              }
                              /* ----------for login show checkout -------------- */
                              if((WSAIO != undefined || WSAIO.main_liquid_file_included) && (typeof WSAIO.isShowCheckout == 'undefined')){
                                  show_checkout()
                              }
                              /* ----------if app undefined show checkout -------------- */
                            
                              if(WSAIO == undefined || !WSAIO.isWholesaleCustomer() && (typeof WSAIO.isShowCheckout == 'undefined')){
                                  show_checkout()
                              }
                          }catch(e){}

                            if (WSAIO.buy_now_btn_replace === false || typeof WSAIO.buyNowEventListener === 'undefined') {
                                const buttonSelectors = '.shopify-payment-button .shopify-payment-button__button';

                                document.querySelectorAll(buttonSelectors).forEach(element => {
                                    element.style.cssText = 'display:inline-block !important';
                                });
                            }
                            document.querySelectorAll('.wsaio_loader_checkout').forEach(element => {
                                element.style.display = 'none';
                            });
                      },1000);
                      if(typeof current_product != 'undefined' && current_product != null){
                        const startSelector2 = '.wsaio_' + current_product.id;
                        document.querySelectorAll(startSelector2).forEach(initialElement => {
                            const productParent3 = initialElement.closest(WSAIO.product_parent_grid_selector);

                            if (productParent3) {
                                const buyNowElement2 = productParent3.querySelector('.wsaio_buynow');

                                if (buyNowElement2) {
                                    buyNowElement2.style.cssText = 'display:inline-block !important';
                                }
                                if (WSAIO.buy_now_btn_replace === false) {
                                    document.querySelectorAll(WSAIO.product_parent_grid_selector).forEach(el => {
                                        if(!el) return false;
                                        if(el.querySelector('.wsaio_buynow')  != null){
                                           el.querySelector('.wsaio_buynow').remove();
                                        }
                                    });
                                    const shopifyButton = productParent3.querySelector('.shopify-payment-button .shopify-payment-button__button');
                                    
                                    if (shopifyButton) {
                                        shopifyButton.style.cssText = 'display:inline-block !important';
                                    }
                                }
                            }
                        });
                      }
                },1050)
            }else{
                const checkoutSelectors = WSAIO.checkout_selector + ',' + WSAIO.duplicate_checkout_selector;
                const checkoutSelectorss = checkoutSelectors.split(',');
                const cleancheckoutSelectorss = checkoutSelectorss.map(sel => sel.trim()).filter(Boolean);
                document.querySelectorAll(cleancheckoutSelectorss).forEach(element => {
                    element.classList.remove('wsaio_hideCheckout');
                });
                document.querySelectorAll('.wsaio_loader_checkout').forEach(element => {
                    element.style.display = 'none';
                });
                const buttonSelectors2 = '.shopify-payment-button .shopify-payment-button__button';
                document.querySelectorAll(buttonSelectors2).forEach(element => {
                    element.style.cssText = 'display:inline-block !important';
                });
            }
        });

 
      WSAIO.run_checkout = function(){
              //  var $ = jQuery;
                if(WSAIO.app_mode_applied){
                const couponSelectors4 = '.wsaio_coupon_group, .wsaio_coupon_link';
                 const sel4 = couponSelectors4.split(',');
                  const cleansel4 = sel4.map(sel => sel.trim()).filter(Boolean);
                  cleansel4.forEach(t => {
                    document.querySelectorAll(t).forEach(element => {
                    element.style.cssText = 'display:block !important';
                });
                  })
                WSAIO.checkoutAlert = document.createElement('ol');
                WSAIO.checkoutAlert.classList.add('wsaio-alerts');
                /*  ==================replace checkout button =============================== */
                if(WSAIO.replace_checkout){
                  const checkoutreplace_checkout = WSAIO.replace_checkout_button;
                  const cleansel2 = checkoutreplace_checkout.split(',');
                  const cleansel22 = cleansel2.map(sel => sel.trim()).filter(Boolean);
                  cleansel22.forEach(t => {
                    document.querySelectorAll(t).forEach(element => {
                      element.insertAdjacentHTML('beforebegin', WSAIO.duplicate_checkout_html);
                      element.remove();
                  });
                  })
                  
                  if(typeof WSAIO.checkoutEventListner != 'undefined' && typeof WSAIO.isWholesaleCustomer != 'undefined' && WSAIO.isWholesaleCustomer() !== false){
                    WSAIO.checkoutEventListner()
                  }else{
                    if(WSAIO.replace_checkout){
                      const checkoutSelectors = WSAIO.checkout_selector + ',' + WSAIO.duplicate_checkout_selector;
                      const checkoutSelectorss = checkoutSelectors.split(',');
                      const cleancheckoutSelectorss = checkoutSelectorss.map(sel => sel.trim()).filter(Boolean);
                      document.querySelectorAll(cleancheckoutSelectorss).forEach(element => {
                        element.addEventListener('click', function(e) {
                            const targetElement = e;
                          if (targetElement) {
                              e.preventDefault();
                              e.stopImmediatePropagation();
                              e.stopPropagation();
                              window.location.href = '/checkout';
                          }
                      });
                      })
                    }
                  }
                  
                }
            
               /*  ==================order limit =============================== */
                if(typeof WSAIO.check_OL !== 'undefined' && WSAIO.check_OL){
                      WSAIO.order_control();WSAIO.disableCheckout();
                }
                if (WSAIO.default_limit) {
                      if (typeof WSAIO.allow_normal_checkout__OC === 'undefined' || WSAIO.allow_normal_checkout__OC === false) {
                          WSAIO.checkoutAlert.insertAdjacentHTML('beforeend', '<li class="waio-orderControl-message">' + WSAIO.checkout_message + "</li>");
                      } else {
                          WSAIO.checkoutAlert.insertAdjacentHTML('beforeend', '<li class="waio-orderControl-message">' + WSAIO.checkout_message + "</li>");
                          WSAIO.checkoutAlert.insertAdjacentHTML('beforeend', '<li class="waio-orderControl-message">Fulfill minimum order requirements to avail discount</li>');
                      }
                }
            
                 /*  ==================Shipping =============================== */
                  if(WSAIO.applied_shipping != undefined && WSAIO.applied_shipping.apply_shipping_charges && document.querySelectorAll('.Shipping_msg').length === 0 && WSAIO.shipping_message_applied){
                     WSAIO.checkoutAlert.insertAdjacentHTML('beforeend', '<div class="Shipping_msg" style="font-weight: 600;font-weight: bold; font-style: italic">' + WSAIO.applied_shipping.final_ship_rule.message + "</div>");
                  }

                 const couponSelectors3 = '.wsaio_coupon_group, .wsaio_coupon_link';
                  const sel2 = couponSelectors3.split(',');
                  const cleansel2 = sel2.map(sel => sel.trim()).filter(Boolean);
                  cleansel2.forEach(t => {
                    document.querySelectorAll(t).forEach(element => {
                      element.style.cssText = 'display:block !important';
                  });
                  })
                  /*  ==================Append all Alerts =============================== */
                  
                  document.querySelectorAll('.wsaio-alerts').forEach(element => {
                      element.remove();
                  });
                  document.querySelectorAll('.waio_agree_message').forEach(element => {
                      element.remove();
                  });
                  if(typeof window.MOQ_alert != 'undefined' && window.MOQ_alert!=''){
                    WSAIO.checkoutAlert = window.MOQ_alert;
                  }else{
                      if (document.querySelectorAll('.wsaio-alerts').length === 0 && WSAIO.checkoutAlert != undefined) {
                             const selectors = WSAIO.checkout_message_selector.split(',');
                            const cleanSelectors = selectors.map(sel => sel.trim()).filter(Boolean);
                            document.querySelectorAll('.wsaio_alerts_div').forEach(function(e){e.remove();});
                            cleanSelectors.forEach(target => {
                                const targetElements = document.querySelectorAll(target);
                                targetElements.forEach(targetele => {
                         if(typeof WSAIO.checkoutAlert == 'string'){
                        const container = document.createElement('div');
                             container.classList.add('wsaio_alerts_div');
                        container.innerHTML = WSAIO.checkoutAlert.trim();
                            if(container.innerHTML.trim() !== ""){
                                                targetele.insertAdjacentElement('afterend', container);
                            }
                        }else{
                                                targetele.insertAdjacentElement('afterend', WSAIO.checkoutAlert.cloneNode(true));
                        }
                                    })
                            })
                      }
                  }

                   WSAIO.cartLevelUpSell();
                  const selectorsToRemove = '.wsaioUsellMessage, .Shipping_msg';
                  const selector1 = selectorsToRemove.split(',');
                  const cleanSelectors1 = selector1.map(sel => sel.trim()).filter(Boolean);
                  cleanSelectors1.forEach(t => {
                    document.querySelectorAll(t).forEach(element => {
                      element.remove();
                  });
                  })
                  if(WSAIO.wsaioUpSell_msg != undefined && WSAIO.wsaioUpSell_msg!= '' && document.querySelectorAll('.wsaioUsellMessage').length === 0){
                    if(typeof WSAIO.cart_level_upsell_message_select == 'undefined' || WSAIO.cart_level_upsell_message_select == ''){
                        const selectors = WSAIO.checkout_message_selector.split(',');
                        const cleanSelectors = selectors.map(sel => sel.trim()).filter(Boolean);
                        cleanSelectors.forEach(target => {
                        const el13 = document.querySelectorAll(target);
                          el13.forEach(targetele => {
                              targetele.insertAdjacentHTML('beforebegin', '<div class="wsaioUsellMessage">' + WSAIO.wsaioUpSell_msg + "</div>");
                      });
                        })
                    }else{
                        const el14 = document.querySelectorAll(WSAIO.cart_level_upsell_message_select);
                        el14.forEach(target => {
                            target.insertAdjacentHTML('beforebegin', '<div class="wsaioUsellMessage">' + WSAIO.wsaioUpSell_msg + "</div>");
                        });
                    }
                  }

                  if(WSAIO.applied_shipping != undefined && WSAIO.applied_shipping.apply_shipping_charges && document.querySelectorAll('.Shipping_msg').length === 0 && WSAIO.shipping_message_applied){
                        const selectors = WSAIO.checkout_message_selector.split(',');
                        const cleanSelectors = selectors.map(sel => sel.trim()).filter(Boolean);
                        cleanSelectors.forEach(target => {
                           const targetElements = document.querySelectorAll(target);
                              targetElements.forEach(targetele => {
                                  targetele.insertAdjacentHTML('afterend', '<div class="Shipping_msg" style="font-weight: 600;font-weight: bold; font-style: italic">' + WSAIO.applied_shipping.final_ship_rule.message + "</div>");
                      });
                         })
                  }
           
                  if (document.querySelectorAll('.wsaio-alerts').length === 0 && WSAIO.checkoutAlert != undefined && typeof window.MOQ_alert != 'undefined' && WSAIO.checkoutAlert.indexOf('<ul class="wsaio-alerts"><li') > -1 ) {
                        const selectors = WSAIO.checkout_message_selector.split(',');
                        const cleanSelectors = selectors.map(sel => sel.trim()).filter(Boolean);
                        document.querySelectorAll('.wsaio_alerts_div').forEach(function(e){e.remove();});
                        cleanSelectors.forEach(target => {
                             const targetElements = document.querySelectorAll(target);
                              targetElements.forEach(targetele => {
                        if(typeof WSAIO.checkoutAlert == 'string'){
                        const container = document.createElement('div');
                             container.classList.add('wsaio_alerts_div');
                        container.innerHTML = WSAIO.checkoutAlert.trim();
                            if(container.innerHTML.trim() !== ""){
                                            targetele.insertAdjacentElement('afterend', container);
                            }
                       }else{
                                            targetele.insertAdjacentElement('afterend', WSAIO.checkoutAlert.cloneNode(true));
                       }
                                })
                        })
                  }


                  
                  if(typeof WSAIO.show_netTerm_btn != 'undefined' && WSAIO.show_netTerm_btn){
                    document.querySelectorAll('.waio__net--wrapper').forEach(element => {
                        element.remove();
                    });
                    if(document.querySelectorAll('.waio__net--wrapper').length === 0){
                        const selectors = WSAIO.checkout_message_selector.split(',');
                        const cleanSelectors = selectors.map(sel => sel.trim()).filter(Boolean);
                        cleanSelectors.forEach(target => {
                           const targetElements = document.querySelectorAll(target);
                              targetElements.forEach(t => t.insertAdjacentHTML('afterend', '<div class="waio__net--wrapper"><div class="btn_stng"><div class="demo_instruction align_mig"><p class="texttt">'+WSAIO.net_cart_label+'</p></div><a href="'+ WSAIO.local_param +'pages/net-term-order" name="netTerm" class=" btn btn-lg align_mig btn" style="pointer-events: none;cursor: default;margin-top: 10px;"> '+WSAIO.net_btn_label+'</a> </div>  </div>'));
                        })
                   }
                    document.querySelectorAll(WSAIO.netTerm_checkout_selector).forEach(element => {
                        element.classList.remove('wsaio_hideCheckout');
                    });
                  }
                  const sel11 = WSAIO.checkout_selector + ',' + WSAIO.duplicate_checkout_selector;
                  const selectors11 = sel11.split(',');
                  const cleanSelectors11 = selectors11.map(sel => sel.trim()).filter(Boolean);
                  cleanSelectors11.forEach(target => {
                  if(typeof WSAIO.isShowCheckout == 'undefined'){
                      document.querySelectorAll(target).forEach(element => {
                        element.classList.remove('wsaio_hideCheckout');
                    });
                  }else{
                      document.querySelectorAll(target).forEach(element => {
                        element.classList.add('wsaio_hideCheckout');
                    });
                  }
                  })

                  if(WSAIO.disable_checkout || window.disable_checkout_MOQ || window.isAgree == false){
                    if(WSAIO.agrrement_alert_message != '' && document.querySelectorAll('.waio_agree_message').length === 0 && typeof window.isAgree != 'undefined' && window.isAgree == false){
                        const sel12 = WSAIO.checkout_message_selector;
                        const selectors12 = sel12.split(',');
                        const cleanSelectors12 = selectors12.map(sel => sel.trim()).filter(Boolean);
                        document.querySelectorAll(cleanSelectors12).forEach(target => {
                          if (target) {
                            const htmlToInsert15 = '<p class="waio_agree_message" style="font-size: 14px;">' + WSAIO.agrrement_alert_message + '</p>';
                              target.insertAdjacentHTML('afterend', htmlToInsert15);
                        }
                        })
                    }
                    if(typeof waioMOC.oc != 'undefined' && typeof waioMOC.oc.allow_retail_price_if_conditions_not_met  != 'undefined' && waioMOC.oc.allow_retail_price_if_conditions_not_met && WSAIO.disable_checkout && (!window.disable_checkout_MOQ || document.querySelectorAll('.moq_error').length === 0) && (typeof window.isAgree == 'undefined' || window.isAgree)){
                            WSAIO.allow_normal_checkout__OC = true;
                            const combinedSelectors = WSAIO.checkout_selector + ',' + WSAIO.duplicate_checkout_selector + ',' + WSAIO.netTerm_checkout_selector;
                              const selectors13 = combinedSelectors.split(',');
                              const cleanSelectors13 = selectors13.map(sel => sel.trim()).filter(Boolean);
                              document.querySelectorAll(cleanSelectors13).forEach(element => {
                                element.classList.remove('checkout-disabled');
                                element.removeAttribute('disabled');
                                element.style.pointerEvents = 'auto';
                                element.style.cursor = 'pointer';
                            });
                    }else{
                        if((typeof WSAIO.allow_normal_checkout__OC != 'undefined' && WSAIO.allow_normal_checkout__OC) && ((!window.disable_checkout_MOQ || document.querySelectorAll('.moq_error').length === 0) && (typeof window.isAgree == 'undefined' || window.isAgree))){
                                const selectors16 = WSAIO.checkout_selector + ',' + WSAIO.duplicate_checkout_selector + ',' + WSAIO.netTerm_checkout_selector;
                                const selectors166 = selectors16.split(',');
                                const cleanSelectors16 = selectors166.map(sel => sel.trim()).filter(Boolean);
                                document.querySelectorAll(cleanSelectors16).forEach(element => {
                                    element.classList.add('checkout-disabled');
                                    element.setAttribute('disabled', 'disabled');
                                    element.style.pointerEvents = 'none';
                                    element.style.cursor = 'default';
                                });
                        }else{
                                const selectors5 = WSAIO.checkout_selector + ',' + WSAIO.duplicate_checkout_selector + ',' + WSAIO.netTerm_checkout_selector;
                                const selectors15 = selectors5.split(',');
                                const cleanSelectors15 = selectors15.map(sel => sel.trim()).filter(Boolean);
                                document.querySelectorAll(cleanSelectors15).forEach(element => {
                                    element.classList.add('checkout-disabled');
                                    element.setAttribute('disabled', 'disabled');
                                    element.style.pointerEvents = 'none';
                                    element.style.cursor = 'default';
                                });
                        }
                    }

                  }else{
                        const selectors6 = WSAIO.checkout_selector + ',' + WSAIO.duplicate_checkout_selector + ',' + WSAIO.netTerm_checkout_selector;
                        const selectors14 = selectors6.split(',');
                        const cleanSelectors14 = selectors14.map(sel => sel.trim()).filter(Boolean);
                        document.querySelectorAll(cleanSelectors14).forEach(element => {
                            element.classList.remove('checkout-disabled');
                            element.removeAttribute('disabled');
                            element.style.pointerEvents = 'auto';
                            element.style.cursor = 'pointer';
                        });
                  }
                  /*  ==================================== =============================== */
               document.querySelectorAll('.wsaio_loader_checkout').forEach(element => {
                    element.style.display = 'none';
                });
        }
    }
    window.addEventListener("load",function(){
        if(typeof WSAIO != 'undefined' && window.wsaio_involved != undefined && window.wsaio_involved == true && typeof WSAIO.preCheckout == 'undefined' && WSAIO.app_mode_applied){
            WSAIO.preloadCheckout = function (){
              WSAIO.showCheckoutLoader();
              try {
                    "undefined" === typeof window.waioMOC && (window.waioMOC = {});
                    "undefined" === typeof waioMOC.cart && (waioMOC.cart = {});
                    try {
                      window.cart_data = WSAIO.cart_object;
                      waioMOC.cart["item_count"] = WSAIO.cart_object.item_count;
                      waioMOC.cart["original_total_price"] = WSAIO.cart_object.original_total_price;
                      WSAIO.order_control()
                      setTimeout(function(){
                        if(typeof WSAIO.loadcartQuantityControllers != 'undefined' && typeof WSAIO.load_checkout_restriction != 'undefined'){ WSAIO.load_checkout_restriction(); WSAIO.loadcartQuantityControllers([],function(e){setTimeout(function(){WSAIO.run_checkout()},1000)});}else{WSAIO.run_checkout()}
                      },1000)
                    } catch (e) {}
                 } catch (e) {}

            };
            WSAIO.preCheckout = function (){
              if(typeof WSAIO.run_checkout != 'undefined'){
                WSAIO.showCheckoutLoader()
                 fetch(WSAIO.local_param + 'cart.json', {
                      method: 'GET',
                      credentials: 'same-origin'
                  })
                  .then(response => response.json())
                  .then(e => {
                    window.cart_data = e;
                    try {
                    "undefined" === typeof window.waioMOC && (window.waioMOC = {});
                    "undefined" === typeof waioMOC.cart && (waioMOC.cart = {});
                        try {
                            waioMOC.cart["item_count"] = e.item_count;
                            waioMOC.cart["original_total_price"] = e.original_total_price;
                      WSAIO.order_control()
                      if(typeof WSAIO.cartQuantityControllers != 'undefined' && typeof WSAIO.checkout_restriction != 'undefined'){ WSAIO.checkout_restriction(); WSAIO.cartQuantityControllers([],function(e){setTimeout(function(){WSAIO.run_checkout()},500)});}else{WSAIO.run_checkout()}
                    } catch (e) {}
                    } catch (e) {}
                })
              }
            };
            WSAIO.preloadCheckout();
        }
       
    })
    if(typeof WSAIO.loginLink != 'undefined')WSAIO.loginLink();
};
/* -----------------------CALL MODULE (End)------------------------------ */